import React from 'react';
import useRoute from '@/Hooks/useRoute';
import { Link } from '@inertiajs/react';

export default function ProjectName({
  project,
}: {
  project: App.Data.ProjectData;
}) {
  const route = useRoute();
  return <Link href={route('sites.show', project.id)}>{project.name}</Link>;
}
